import {Controller} from "stimulus"
import $ from 'jquery';
import {get} from '@rails/request.js'
import flatpickr from "flatpickr";
import {create_array_for_product} from "./b2b_controller";


export default class extends Controller {
    static targets = ["agencySelect", "destinationsSelect", "dealerSelect", "contractSelect", "categorySelect", "fromDate", "toDate", "fromTime", "toTime", "pickupOffice", "dropoffOffice", "divTariffModality", "divSupplements", "tariffSelect", "modalitySelect", "driversSelect", "supplementInsuranceSelect", "divClient", "countrySelect", "agencyContinueBookingBtn"]

    connect() {
        const editing = this.element.dataset.agencyEditing === 'true';
        if (editing) {
            const raw = this.element.dataset.agencyPrefillVoucher;
            if (raw) {
                try { this._prefill = JSON.parse(raw); } catch(e) {}
            }

            // Inicializar flatpickr con los valores del voucher una vez que
            // select2 y el DOM estén listos
            setTimeout(() => {
                if (this.hasCategorySelectTarget && this.categorySelectTarget.value) {
                    this.from_to_flatpickr();  // ← inicializa con defaultDate del input
                }
            }, 300);
        }
    }

    _runPrefill() {
        const el = this.element;
        const editing = el.dataset.agencyEditing === 'true';
        if (!editing) return;

        const raw = el.dataset.agencyPrefillVoucher;
        if (!raw) return;

        try {
            this._prefill = JSON.parse(raw);
        } catch (e) {
            console.error('Error parseando prefill voucher:', e);
            return;
        }

        this._isPrefilling = true;

        if (this._prefill.agency && this.hasAgencySelectTarget) {
            // Seleccionar agencia → dispara change.select2 → getDestinations() → _afterDestinationsLoaded()
            $(this.agencySelectTarget).val(this._prefill.agency).trigger('change');
        } else if (this._prefill.destination && this.hasDestinationsSelectTarget) {
            // Usuario agency normal: el destino ya está en el select desde el servidor
            $(this.destinationsSelectTarget).val(this._prefill.destination).trigger('change');
        }
    }

    _prefillDates() {
        if (!this._prefill) return;

        const [fromDate, fromTime] = (this._prefill.from || '').split(' ');
        const [toDate, toTime] = (this._prefill.to || '').split(' ');

        const fromEl = document.getElementById('agency_from');
        const toEl = document.getElementById('agency_to');

        if (fromEl?._flatpickr && fromDate) fromEl._flatpickr.setDate(fromDate);
        $(this.fromDateTarget).val(fromDate || '');
        $('#agency_from_time').val(fromTime || '');
        $(this.fromTimeTarget).val(fromTime || '');

        if (toEl?._flatpickr && toDate) toEl._flatpickr.setDate(toDate);
        $(this.toDateTarget).val(toDate || '');
        $('#agency_to_time').val(toTime || '');
        $(this.toTimeTarget).val(toTime || '');

        // Campos de texto del cliente
        $('[name="booking[client_name]"]').val(this._prefill.client_name || '');
        $('[name="booking[client_lastname]"]').val(this._prefill.client_lastname || '');
        $('[name="booking[client_email]"]').val(this._prefill.client_email || '');
        $('[name="booking[client_passport]"]').val(this._prefill.client_passport || '');
        $('[name="booking[client_flight]"]').val(this._prefill.client_flight || '');
        $('[name="booking[client_details]"]').val(this._prefill.client_details || '');
        $('[name="booking[business_reference2]"]').val(this._prefill.business_reference2 || '');
        $('[name="booking[business_reference3]"]').val(this._prefill.business_reference3 || '');

        // Selects simples (drivers, supplement_insurance, country)
        $('[name="booking[drivers]"]').val(this._prefill.drivers || '0');
        $('[name="booking[supplement_insurance]"]').val(this._prefill.supplement_insurance || '0');

        if (this.hasCountrySelectTarget) {
            $(this.countrySelectTarget).val(this._prefill.client_country || '').trigger('change');
        }
    }

    initialize() {
        let context = this;

        // ─── AGENCIA (solo para admin_agency, el elemento puede no existir) ───
        if (this.hasAgencySelectTarget) {
            $(this.agencySelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una agencia",
                allowClear: true
            }).on('change.select2', function () {
                // Este se dispara tanto en selección manual como en trigger programático
                const val = context.agencySelectTarget.selectedOptions[0]?.value;
                if (val?.length > 0) {
                    context.getDestinations();
                }
            }).on('select2:unselecting', function () {
                context._resetFromDestinations();
            });
        }

        /* DESTINOS */
        if (this.hasDestinationsSelectTarget) {
            $(this.destinationsSelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione un destino",
                allowClear: true
            }).on('select2:select', function () {
                $(context.dealerSelectTarget).removeAttr('disabled');
                $(context.dealerSelectTarget).empty();
                $(context.contractSelectTarget).prop('disabled', true);
                $(context.contractSelectTarget).empty();
                $(context.categorySelectTarget).prop('disabled', true);
                $(context.categorySelectTarget).empty();
            }).on('select2:unselecting', function () {
                // console.info('unselecting destino');
                $(context.dealerSelectTarget).prop('disabled', true);
                $(context.dealerSelectTarget).empty();

                $(context.contractSelectTarget).prop('disabled', true);
                $(context.contractSelectTarget).empty();

                $(context.categorySelectTarget).prop('disabled', true);
                $(context.categorySelectTarget).empty();

                $('#agency_from')[0]._flatpickr?.clear();
                $(context.fromDateTarget).val('');
                $('#agency_to')[0]._flatpickr?.clear();
                $(context.toDateTarget).val('');
                $('#agency_from_time').val('');
                $(context.fromTimeTarget).val('');
                $('#agency_to_time').val('');
                $(context.toTimeTarget).val('');

                $(context.pickupOfficeTarget).prop('disabled', true);
                $(context.pickupOfficeTarget).empty();
                $(context.dropoffOfficeTarget).prop('disabled', true);
                $(context.dropoffOfficeTarget).empty();

                $(context.tariffSelectTarget).prop('disabled', true);
                $(context.tariffSelectTarget).empty();
                $(context.modalitySelectTarget).prop('disabled', true);
                $(context.modalitySelectTarget).empty();

                $(context.divTariffModalityTarget).css('display', 'none');
                $(context.divSupplementsTarget).css('display', 'none');
                $(context.driversSelectTarget).prop('disabled', true);
                $(context.supplementInsuranceSelectTarget).prop('disabled', true);

                $(context.divClientTarget).css('display', 'none');
            }).on('change.select2', () => {
                if (context._isPrefilling) return;
                // console.info('change destino');
                if (context.destinationsSelectTarget.selectedOptions[0]?.value?.length > 0) {
                    context.getDealer();
                }
                if (context.destinationsSelectTarget.options.length === 1) {
                    $(context.dealerSelectTarget).removeAttr('disabled');
                    $(context.dealerSelectTarget).empty();
                    $(context.contractSelectTarget).prop('disabled', true);
                    $(context.contractSelectTarget).empty();
                    $(context.categorySelectTarget).prop('disabled', true);
                    $(context.categorySelectTarget).empty();

                    context.getDealer();
                }

                $(context.categorySelectTarget).prop('disabled', true);
                $(context.categorySelectTarget).empty();

                $('#agency_from')[0]._flatpickr?.clear();
                $(context.fromDateTarget).val('');
                $('#agency_to')[0]._flatpickr?.clear();
                $(context.toDateTarget).val('');
                $('#agency_from_time').val('');
                $(context.fromTimeTarget).val('');
                $('#agency_to_time').val('');
                $(context.toTimeTarget).val('');

                $(context.pickupOfficeTarget).prop('disabled', true);
                $(context.pickupOfficeTarget).empty();
                $(context.dropoffOfficeTarget).prop('disabled', true);
                $(context.dropoffOfficeTarget).empty();

                $(context.tariffSelectTarget).prop('disabled', true);
                $(context.tariffSelectTarget).empty();
                $(context.modalitySelectTarget).prop('disabled', true);
                $(context.modalitySelectTarget).empty();

                $(context.divTariffModalityTarget).css('display', 'none');
                $(context.divSupplementsTarget).css('display', 'none');
                $(context.driversSelectTarget).prop('disabled', true);
                $(context.supplementInsuranceSelectTarget).prop('disabled', true);
            });
        }

        /* PRESTATARIOS */
        if (this.hasDealerSelectTarget) {
            $(this.dealerSelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una sucursal",
                allowClear: true
            }).on('change.select2', () => {
                if (context._isPrefilling) return;
                // console.log('change dealer');

                $(context.contractSelectTarget).prop('disabled', true);
                $(context.contractSelectTarget).empty();

                $(context.categorySelectTarget).prop('disabled', true);
                $(context.categorySelectTarget).empty();

                $('#agency_from')[0]._flatpickr?.clear();
                $(context.fromDateTarget).val('');
                $('#agency_to')[0]._flatpickr?.clear();
                $(context.toDateTarget).val('');
                $('#agency_from_time').val('');
                $(context.fromTimeTarget).val('');
                $('#agency_to_time').val('');
                $(context.toTimeTarget).val('');

                $(context.pickupOfficeTarget).prop('disabled', true);
                $(context.pickupOfficeTarget).empty();
                $(context.dropoffOfficeTarget).prop('disabled', true);
                $(context.dropoffOfficeTarget).empty();

                $(context.tariffSelectTarget).prop('disabled', true);
                $(context.tariffSelectTarget).empty();
                $(context.modalitySelectTarget).prop('disabled', true);
                $(context.modalitySelectTarget).empty();

                $(context.divTariffModalityTarget).css('display', 'none');
                $(context.divSupplementsTarget).css('display', 'none');
                $(context.driversSelectTarget).prop('disabled', true);
                $(context.supplementInsuranceSelectTarget).prop('disabled', true);

                $(context.divClientTarget).css('display', 'none');

                if (this.dealerSelectTarget.options.length === 1) {
                    context.getContract();
                    $(context.dealerSelectTarget).removeAttr('disabled');
                    $(context.contractSelectTarget).removeAttr('disabled');
                    $(context.contractSelectTarget).empty();
                } else {
                    context.getContract();
                    $(this.dealerSelectTarget).removeAttr('disabled');
                }
            }).on('select2:select', function () {
                // console.log('select dealer');
                $(context.contractSelectTarget).removeAttr('disabled');
                $(context.contractSelectTarget).empty();
            }).on('select2:unselecting', function () {
                // console.log('unselecting dealer');

                $(context.contractSelectTarget).prop('disabled', true);
                $(context.contractSelectTarget).empty();

                $(context.categorySelectTarget).prop('disabled', true);
                $(context.categorySelectTarget).empty();

                $('#agency_from')[0]._flatpickr?.clear();
                $(context.fromDateTarget).val('');
                $('#agency_to')[0]._flatpickr?.clear();
                $(context.toDateTarget).val('');
                $('#agency_from_time').val('');
                $(context.fromTimeTarget).val('');
                $('#agency_to_time').val('');
                $(context.toTimeTarget).val('');

                $(context.pickupOfficeTarget).prop('disabled', true);
                $(context.pickupOfficeTarget).empty();
                $(context.dropoffOfficeTarget).prop('disabled', true);
                $(context.dropoffOfficeTarget).empty();

                $(context.tariffSelectTarget).prop('disabled', true);
                $(context.tariffSelectTarget).empty();
                $(context.modalitySelectTarget).prop('disabled', true);
                $(context.modalitySelectTarget).empty();

                $(context.divTariffModalityTarget).css('display', 'none');
                $(context.divSupplementsTarget).css('display', 'none');
                $(context.driversSelectTarget).prop('disabled', true);
                $(context.supplementInsuranceSelectTarget).prop('disabled', true);
            });
        }

        /* CONTRATOS */
        if (this.hasContractSelectTarget) {
            $(this.contractSelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione un contrato",
                allowClear: true
            }).on('change.select2', () => {
                if (context._isPrefilling) return;
                // console.info('change contract');

                if (context.contractSelectTarget.selectedOptions[0]?.value?.length > 0) {
                    $(context.categorySelectTarget).removeAttr('disabled')
                    $(context.contractSelectTarget).removeAttr('disabled');
                    context.getCategory();
                }

                $(context.categorySelectTarget).prop('disabled', true);
                $(context.categorySelectTarget).empty();

                $('#agency_from')[0]._flatpickr?.clear();
                $(context.fromDateTarget).val('');
                $('#agency_to')[0]._flatpickr?.clear();
                $(context.toDateTarget).val('');
                $('#agency_from_time').val('');
                $(context.fromTimeTarget).val('');
                $('#agency_to_time').val('');
                $(context.toTimeTarget).val('');

                $(context.pickupOfficeTarget).prop('disabled', true);
                $(context.pickupOfficeTarget).empty();
                $(context.dropoffOfficeTarget).prop('disabled', true);
                $(context.dropoffOfficeTarget).empty();

                $(context.tariffSelectTarget).prop('disabled', true);
                $(context.tariffSelectTarget).empty();
                $(context.modalitySelectTarget).prop('disabled', true);
                $(context.modalitySelectTarget).empty();

                $(context.divTariffModalityTarget).css('display', 'none');
                $(context.divSupplementsTarget).css('display', 'none');
                $(context.driversSelectTarget).prop('disabled', true);
                $(context.supplementInsuranceSelectTarget).prop('disabled', true);
            }).on('select2:select', function () {
                // console.info('select contract');
                if (context.contractSelectTarget.selectedOptions[0]?.value?.length > 0) {
                    $(context.categorySelectTarget).removeAttr('disabled');
                    $(context.categorySelectTarget).empty();
                }
            }).on('select2:unselecting', function () {
                // console.info('unselecting contract');
                $(context.categorySelectTarget).prop('disabled', true);
                $(context.categorySelectTarget).empty();

                $('#agency_from')[0]._flatpickr?.clear();
                $(context.fromDateTarget).val('');
                $('#agency_to')[0]._flatpickr?.clear();
                $(context.toDateTarget).val('');
                $('#agency_from_time').val('');
                $(context.fromTimeTarget).val('');
                $('#agency_to_time').val('');
                $(context.toTimeTarget).val('');

                $(context.pickupOfficeTarget).prop('disabled', true);
                $(context.pickupOfficeTarget).empty();
                $(context.dropoffOfficeTarget).prop('disabled', true);
                $(context.dropoffOfficeTarget).empty();

                $(context.tariffSelectTarget).prop('disabled', true);
                $(context.tariffSelectTarget).empty();
                $(context.modalitySelectTarget).prop('disabled', true);
                $(context.modalitySelectTarget).empty();

                $(context.divTariffModalityTarget).css('display', 'none');
                $(context.divSupplementsTarget).css('display', 'none');
                $(context.driversSelectTarget).prop('disabled', true);
                $(context.supplementInsuranceSelectTarget).prop('disabled', true);

                $(context.divClientTarget).css('display', 'none');
            });
        }

        /* CATEGORIAS */
        if (this.hasCategorySelectTarget) {
            $(this.categorySelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una categoría",
                allowClear: true
            }).on('change.select2', () => {
                if (context._isPrefilling) return;
                // console.info('change category');
                if (this.categorySelectTarget.options.length === 1) {
                    /* nada aún */
                } else {
                    $(this.categorySelectTarget).removeAttr('disabled');
                }
            }).on('select2:select', function () {
                // console.info('select2 category');
                context.from_to_flatpickr();
                context.getTariff();
                context.getModality();

                $(context.divTariffModalityTarget).removeAttr('style');
                $(context.divSupplementsTarget).removeAttr('style');
                $(context.driversSelectTarget).removeAttr('disabled');
                $(context.supplementInsuranceSelectTarget).removeAttr('disabled');
                $(context.tariffSelectTarget).removeAttr('disabled');
                $(context.modalitySelectTarget).removeAttr('disabled');
            }).on('select2:unselecting', function () {
                // console.info('unselecting category');

                $('#agency_from')[0]._flatpickr?.clear();
                $(context.fromDateTarget).val('');
                $('#agency_to')[0]._flatpickr?.clear();
                $(context.toDateTarget).val('');
                $('#agency_from_time').val('');
                $(context.fromTimeTarget).val('');
                $('#agency_to_time').val('');
                $(context.toTimeTarget).val('');

                $(context.pickupOfficeTarget).prop('disabled', true);
                $(context.pickupOfficeTarget).empty();
                $(context.dropoffOfficeTarget).prop('disabled', true);
                $(context.dropoffOfficeTarget).empty();

                $(context.tariffSelectTarget).prop('disabled', true);
                $(context.tariffSelectTarget).empty();
                $(context.modalitySelectTarget).prop('disabled', true);
                $(context.modalitySelectTarget).empty();

                $(context.divTariffModalityTarget).css('display', 'none');
                $(context.divSupplementsTarget).css('display', 'none');
                $(context.driversSelectTarget).prop('disabled', true);
                $(context.supplementInsuranceSelectTarget).prop('disabled', true);

                $(context.divClientTarget).css('display', 'none');
            });
        }

        /* OFICINA DE RECOGIDA */
        if (this.hasPickupOfficeTarget) {
            $(this.pickupOfficeTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una oficina",
                allowClear: true
            }).on('change.select2', () => {
                // console.info('change pickupoffice');
                context.getDropoffOffice();
                $(context.pickupOfficeTarget).removeAttr('disabled');

                if (context.pickupOfficeTarget.selectedOptions.length > 0) {
                    if (!context.pickupOfficeTarget.selectedOptions[0].value.isEmpty()) {
                        /* ErnePazzo para que la hora de entrega sea por los datos apertura y cierre de la oficina */
                        /*if (context.pickupOfficeTarget.selectedOptions[0].dataset.fullTime === 'true') {
                            let to_time = $(context.fromTimeTarget).val()
                            $('#agency_to_time').val(to_time);
                            $(context.toTimeTarget).val(to_time);
                        } else {
                            flatpickr("#agency_to_time", {
                                enableTime: true,
                                noCalendar: true,
                                dateFormat: "H:i",
                                altFormat: "H:i",
                                time_24hr: true,
                                minDate: context.pickupOfficeTarget.selectedOptions[0].dataset.openTime,
                                maxDate: context.pickupOfficeTarget.selectedOptions[0].dataset.closeTime,
                                locale: 'es',
                                disableMobile: "true",
                            })
                        }*/
                    }
                }
            }).on('select2:select', function () {
                // console.info('select2 pickupoffice');
                /*context.getDropoffOffice();*/
            }).on('select2:unselecting', function () {
                // console.info('unselecting pickupoffice');

                $('#agency_to_time').val('');
                $(context.toTimeTarget).val('');

                $(context.divClientTarget).css('display', 'none');
            });
        }

        /* OFICINA DE ENTREGA */
        if (this.hasDropoffOfficeTarget) {
            $(this.dropoffOfficeTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una oficina",
                allowClear: true
            }).on('change.select2', () => {
                // console.info('change dropoffoffice');
                if (this.dropoffOfficeTarget.options.length === 1) {
                    /* nada aún */
                } else {
                    $(this.dropoffOfficeTarget).removeAttr('disabled');
                }
            }).on('select2:select', function () {
                // console.info('select2 dropoffoffice');

                if (context.dropoffOfficeTarget.selectedOptions.length > 0) {
                    if (!context.dropoffOfficeTarget.selectedOptions[0].value.isEmpty()) {
                        $(context.divClientTarget).removeAttr('style');
                    }
                }
            }).on('select2:unselecting', function () {
                // console.info('unselecting dropoffoffice');

                $(context.divClientTarget).css('display', 'none');
            });
        }

        /* TARIFA */
        if (this.hasTariffSelectTarget) {
            $(this.tariffSelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una tarifa",
                allowClear: true
            }).on('change.select2', () => {
                // console.info('change tariff');
                if (this.tariffSelectTarget.options.length === 1) {
                    /* nada aún */
                } else {
                    $(this.tariffSelectTarget).removeAttr('disabled');
                }
            }).on('select2:select', function () {
                // console.info('select2 tariff');
            }).on('select2:unselecting', function () {
                // console.info('unselecting tariff');
            });
        }

        /* MODALIDAD */
        if (this.hasModalitySelectTarget) {
            $(this.modalitySelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una modalidad",
                allowClear: true
            }).on('change.select2', () => {
                // console.info('change modality');
                if (context.modalitySelectTarget.options.length === 1) {
                } else {
                    $(context.modalitySelectTarget).removeAttr('disabled');
                }
            }).on('select2:select', function () {
                // console.info('select2 modality');
            }).on('select2:unselecting', function () {
                // console.info('unselecting modality');
            });
        }

        /* CHOFER ADICIONAL */
        if (this.hasDriversSelectTarget) {
            $(this.driversSelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una opción",
                allowClear: true
            }).on('change.select2', () => {
                // console.info('change drivers');
                if (this.driversSelectTarget.options.length === 1) {
                    /* nada aún */
                } else {
                    $(this.driversSelectTarget).removeAttr('disabled');
                }
            }).on('select2:select', function () {
                // console.info('select2 drivers');
            }).on('select2:unselecting', function () {
                // console.info('unselecting drivers');
            });
        }

        /* SUPLEMENTO RESPONSABILIDAD ADICIONAL */
        if (this.hasSupplementInsuranceSelectTarget) {
            $(this.supplementInsuranceSelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una opción",
                allowClear: true
            }).on('change.select2', () => {
                // console.info('change supplementInsuranceSelect');
                if (this.supplementInsuranceSelectTarget.options.length === 1) {
                    /* nada aún */
                } else {
                    $(this.supplementInsuranceSelectTarget).removeAttr('disabled');
                }
            }).on('select2:select', function () {
                // console.info('select2 supplementInsuranceSelect');
            }).on('select2:unselecting', function () {
                // console.info('unselecting supplementInsuranceSelect');
            });
        }

        /* PAÍS */
        if (this.hasCountrySelectTarget) {
            $(this.countrySelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione un país",
                allowClear: true
            }).on('change.select2', () => {
                // console.info('change country');
            }).on('select2:select', function () {
                // console.info('select2 country');
            }).on('select2:unselecting', function () {
                // console.info('unselecting country');
            });
        }
    }

    /* Para cuando se da click pero estas sin loguear */
    isLogin(r) {
        if (r.responseText && typeof r.responseText.then === 'function') {
            r.responseText.then((v) => {
                let value = v.trim();

                if (value.includes("login")) {
                    window.location.href = v.trim();
                }
            })
        }
        if (r.response && typeof r.response.then === 'function') {
            r.response.then((v) => {
                let value = v.trim();

                if (value.includes("login")) {
                    window.location.href = v.trim();
                }
            })
        } else {
            if (r.response.url.includes("login")) {
                window.location.href = r.response.url;
            }
        }
    }

    // ─── NUEVO MÉTODO: obtener destinos al cambiar agencia ───
    getDestinations() {
        const agencyId = this.agencySelectTarget.selectedOptions[0]?.value;
        if (!agencyId) return;

        this._resetFromDestinations();

        get(`/agency/get_destinations`, {
            query: {
                agency_id: agencyId,
                target: this.destinationsSelectTarget.id
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.isLogin(r);
            this._afterDestinationsLoaded();
        });
    }

    _afterDestinationsLoaded() {
        setTimeout(() => {
            if (!this.hasDestinationsSelectTarget) return;

            const select = this.destinationsSelectTarget;
            $(select).removeAttr('disabled');

            if (this._isPrefilling && this._prefill?.destination) {
                // Modo prefill: seleccionar el destino del voucher directamente
                $(select).val(this._prefill.destination).trigger('change.select2');
            } else if (select.options.length === 2) {
                // Una sola opción: auto-seleccionar
                $(select).val(select.options[1].value).trigger('change.select2');
            }
            // Si hay múltiples opciones y no es prefill: el usuario elige
        }, 500);
    }

    _resetFromDestinations() {
        // Cada acceso protegido con has*Target
        if (this.hasDestinationsSelectTarget) {
            $(this.destinationsSelectTarget).prop('disabled', true).empty();
        }
        if (this.hasDealerSelectTarget) {
            $(this.dealerSelectTarget).prop('disabled', true).empty();
        }
        if (this.hasContractSelectTarget) {
            $(this.contractSelectTarget).prop('disabled', true).empty();
        }
        if (this.hasCategorySelectTarget) {
            $(this.categorySelectTarget).prop('disabled', true).empty();
        }

        const fromEl = document.getElementById('agency_from');
        if (fromEl?._flatpickr) fromEl._flatpickr.clear();
        if (this.hasFromDateTarget) $(this.fromDateTarget).val('');

        const toEl = document.getElementById('agency_to');
        if (toEl?._flatpickr) toEl._flatpickr.clear();
        if (this.hasToDateTarget) $(this.toDateTarget).val('');

        $('#agency_from_time').val('');
        if (this.hasFromTimeTarget) $(this.fromTimeTarget).val('');
        $('#agency_to_time').val('');
        if (this.hasToTimeTarget) $(this.toTimeTarget).val('');

        if (this.hasPickupOfficeTarget) {
            $(this.pickupOfficeTarget).prop('disabled', true).empty();
        }
        if (this.hasDropoffOfficeTarget) {
            $(this.dropoffOfficeTarget).prop('disabled', true).empty();
        }
        if (this.hasTariffSelectTarget) {
            $(this.tariffSelectTarget).prop('disabled', true).empty();
        }
        if (this.hasModalitySelectTarget) {
            $(this.modalitySelectTarget).prop('disabled', true).empty();
        }
        if (this.hasDivTariffModalityTarget) {
            $(this.divTariffModalityTarget).css('display', 'none');
        }
        if (this.hasDivSupplementsTarget) {
            $(this.divSupplementsTarget).css('display', 'none');
        }
        if (this.hasDriversSelectTarget) {
            $(this.driversSelectTarget).prop('disabled', true);
        }
        if (this.hasSupplementInsuranceSelectTarget) {
            $(this.supplementInsuranceSelectTarget).prop('disabled', true);
        }
        if (this.hasDivClientTarget) {
            $(this.divClientTarget).css('display', 'none');
        }
    }

    /* De Destination a Dealer */
    getDealer() {
        const agencyId = this._getAgencyId();

        get(`/agency/get_dealers`, {
            query: {
                destination_id: this.destinationsSelectTarget.selectedOptions[0].value,
                target: this.dealerSelectTarget.id,
                ...(agencyId && {agency_id: agencyId})  // solo si existe
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.isLogin(r);
            this.setDealerData()
        });
    }

    setDealerData() {
        setTimeout(() => {
            if (this._isPrefilling && this._prefill?.dealer) {
                // En prefill: habilitar, seleccionar y continuar cascade
                $(this.dealerSelectTarget).removeAttr('disabled');
                $(this.dealerSelectTarget).val(this._prefill.dealer).trigger('change.select2');
            } else {
                // Comportamiento normal
                if (this.dealerSelectTarget.options.length === 1) {
                    $(this.dealerSelectTarget).trigger({type: 'change.select2'});
                } else {
                    $(this.dealerSelectTarget).removeAttr('disabled');
                }
            }
        }, 500);
    }

    /* De Dealer a Contract */
    getContract() {
        const agencyId = this._getAgencyId();

        get(`/agency/get_contracts`, {
            query: {
                target: this.contractSelectTarget.id,
                ...(agencyId && {agency_id: agencyId})  // solo si existe
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.isLogin(r);
            this.setContractData()
        })
    }

    setContractData() {
        setTimeout(() => {
            if (this._isPrefilling && this._prefill?.contract) {
                $(this.contractSelectTarget).removeAttr('disabled');
                $(this.contractSelectTarget).val(this._prefill.contract).trigger('change.select2');
            } else {
                if (this.contractSelectTarget.options.length === 1) {
                    $(this.contractSelectTarget).trigger({type: 'change.select2'});
                } else {
                    $(this.categorySelectTarget).val('');
                    $(this.categorySelectTarget).prop('disabled', true);
                }
            }
        }, 500);
    }

    /* De Contract a Category */
    getCategory() {
        const agencyId = this._getAgencyId();

        get(`/agency/get_categories`, {
            query: {
                target: this.categorySelectTarget.id,
                ...(agencyId && {agency_id: agencyId})  // solo si existe
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.isLogin(r);
            this.setCategoryData()
        })
    }

    setCategoryData() {
        setTimeout(() => {
            if (this._isPrefilling && this._prefill?.category) {
                $(this.categorySelectTarget).removeAttr('disabled');
                $(this.categorySelectTarget).val(this._prefill.category).trigger('change.select2');
            } else {
                if (this.categorySelectTarget.options.length === 1) {
                    $(this.categorySelectTarget).trigger({type: 'change.select2'});
                } else {
                    $(this.categorySelectTarget).removeAttr('disabled');
                }
            }
        }, 500);
    }

    from_to_flatpickr() {
        const editing = this.element.dataset.agencyEditing === 'true';

        let category_option = $(this.categorySelectTarget.selectedOptions[0]);
        let min_length_reservation = parseInt(category_option.data('min-length-reservation')) || 0;
        let max_length_reservation = parseInt(category_option.data('max-length-reservation')) || 30;

        // ← Leer desde el hidden field que siempre tiene Y-m-d, no del input visible
        const existingFrom = $(this.fromDateTarget).val();  // booking[from]
        const existingFromTime = $(this.fromTimeTarget).val();
        const existingTo = $(this.toDateTarget).val();
        const existingToTime = $(this.toTimeTarget).val();

        flatpickr("#agency_from", {
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d",
            disableMobile: "true",
            minDate: editing ? null : new Date().fp_incr(min_length_reservation),
            defaultDate: existingFrom || null,
            locale: 'es'
        });

        flatpickr("#agency_from_time", {
            enableTime: true,
            noCalendar: true,
            dateFormat: "H:i",
            altFormat: "H:i",
            time_24hr: true,
            locale: 'es',
            disableMobile: "true",
            defaultDate: existingFromTime || null
        });

        if (editing && existingFrom) {
            // existingFrom ya viene en Y-m-d desde el hidden field → Date() lo parsea bien
            let fecha_min = new Date(existingFrom + 'T00:00:00');  // forzar medianoche local
            fecha_min.setDate(fecha_min.getDate() + min_length_reservation);
            let fecha_max = new Date(existingFrom + 'T00:00:00');
            fecha_max.setDate(fecha_max.getDate() + max_length_reservation);

            flatpickr("#agency_to", {
                altInput: true,
                altFormat: "d-m-Y",
                dateFormat: "Y-m-d",
                disableMobile: "true",
                minDate: fecha_min.toISOString().split('T')[0],
                maxDate: fecha_max.toISOString().split('T')[0],
                defaultDate: existingTo || null,
                locale: 'es'
            });

            flatpickr("#agency_to_time", {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                altFormat: "H:i",
                time_24hr: true,
                locale: 'es',
                disableMobile: "true",
                defaultDate: existingToTime || null
            });
        }

        // ─── Eventos — igual que antes ───
        $('#agency_from').on('change', (e) => {
            let agency_from_value = e.target.value;

            if (agency_from_value !== '') {
                $(this.fromDateTarget).val(agency_from_value);

                let fecha_min = new Date(agency_from_value + 'T00:00:00');
                fecha_min.setDate(fecha_min.getDate() + min_length_reservation);
                let fecha_max = new Date(agency_from_value + 'T00:00:00');
                fecha_max.setDate(fecha_max.getDate() + max_length_reservation);

                flatpickr("#agency_to", {
                    altInput: true,
                    altFormat: "d-m-Y",
                    dateFormat: "Y-m-d",
                    disableMobile: "true",
                    minDate: fecha_min.toISOString().split('T')[0],
                    maxDate: fecha_max.toISOString().split('T')[0],
                    locale: 'es'
                });
            }
        });

        $('#agency_to').on('change', (e) => {
            $(this.toDateTarget).val(e.target.value);
            let to_time = $(this.fromTimeTarget).val();
            $('#agency_to_time').val(to_time);
            $(this.toTimeTarget).val(to_time);
        });

        $('#agency_from_time').on('change', (e) => {
            $(this.fromTimeTarget).val(e.target.value);
            this.getPickupOffice();
        });

        $('#agency_to_time').on('change', (e) => {
            $(this.toTimeTarget).val(e.target.value);
        });
    }

    /* De Category a PickupOffice */
    getPickupOffice() {
        const agencyId = this._getAgencyId();

        get(`/agency/get_pickup_office`, {
            query: {
                destination_id: this.destinationsSelectTarget.selectedOptions[0].value,
                dealer_id: this.dealerSelectTarget.selectedOptions[0].value,
                from_time: $(this.fromTimeTarget).val(),
                target: this.pickupOfficeTarget.id,
                ...(agencyId && {agency_id: agencyId})  // solo si existe
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.isLogin(r);
            this.setPickupOfficeData()
        })
    }

    setPickupOfficeData() {
        setTimeout(() => {
            if (this._isPrefilling && this._prefill?.pickup) {
                $(this.pickupOfficeTarget).removeAttr('disabled');
                $(this.pickupOfficeTarget).val(this._prefill.pickup).trigger('change.select2');
            } else {
                if (this.pickupOfficeTarget.options.length === 1) {
                    $(this.pickupOfficeTarget).trigger({type: 'change.select2'});
                } else {
                    $(this.pickupOfficeTarget).removeAttr('disabled');
                }
            }
        }, 500);
    }

    /* De PickupOffice a DropoffOffice */
    getDropoffOffice() {
        const agencyId = this._getAgencyId();

        get(`/agency/get_dropoff_office`, {
            query: {
                target: this.dropoffOfficeTarget.id,
                ...(agencyId && {agency_id: agencyId})  // solo si existe
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.isLogin(r);
            this.setDropoffOfficeData()
        })
    }

    setDropoffOfficeData() {
        setTimeout(() => {
            if (this._isPrefilling && this._prefill?.dropoff) {
                $(this.dropoffOfficeTarget).removeAttr('disabled');
                $(this.dropoffOfficeTarget).val(this._prefill.dropoff).trigger('change.select2');

                // Último del cascade — cerrar prefill, mostrar cliente y cargar fechas
                this._isPrefilling = false;
                $(this.divClientTarget).removeAttr('style');
                this._prefillDates();
            } else {
                if (this.dropoffOfficeTarget.options.length === 1) {
                    $(this.dropoffOfficeTarget).trigger({type: 'change.select2'});
                } else {
                    $(this.dropoffOfficeTarget).removeAttr('disabled');
                }
            }
        }, 500);
    }

    /* De Category a Tariff */
    getTariff() {
        const agencyId = this._getAgencyId();

        get(`/agency/get_tariffs`, {
            query: {
                contract_id: this.contractSelectTarget.selectedOptions[0].value,
                target: this.tariffSelectTarget.id,
                ...(agencyId && {agency_id: agencyId})  // solo si existe
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.isLogin(r);
            this.setTariffData()
        })
    }

    setTariffData() {
        setTimeout(() => {
            if (this._isPrefilling && this._prefill?.tariff) {
                $(this.tariffSelectTarget).removeAttr('disabled');
                $(this.tariffSelectTarget).val(this._prefill.tariff).trigger('change.select2');
            } else {
                if (this.tariffSelectTarget.options.length === 1) {
                    $(this.tariffSelectTarget).trigger({type: 'change.select2'});
                } else {
                    $(this.tariffSelectTarget).removeAttr('disabled');
                }
            }
        }, 500);
    }

    /* De Category a Modality */
    getModality() {
        const agencyId = this._getAgencyId();

        get(`/agency/get_modalities`, {
            query: {
                product_id: this.categorySelectTarget.selectedOptions[0].value,
                target: this.modalitySelectTarget.id,
                ...(agencyId && {agency_id: agencyId})  // solo si existe
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.isLogin(r);
            this.setModalityData()
        })
    }

    setModalityData() {
        setTimeout(() => {
            if (this._isPrefilling && this._prefill?.modality) {
                $(this.modalitySelectTarget).removeAttr('disabled');
                $(this.modalitySelectTarget).val(this._prefill.modality).trigger('change.select2');
            } else {
                if (this.modalitySelectTarget.options.length === 1) {
                    $(this.modalitySelectTarget).trigger({type: 'change.select2'});
                } else {
                    $(this.modalitySelectTarget).removeAttr('disabled');
                }
            }
        }, 500);
    }


    open_tree(e) {
        e.target.parentElement.querySelector(".nested-bl").classList.toggle("active-bl");
        e.target.classList.toggle("caret-down-bl");
    }

    validate_emails(e) {
        let value = $.trim(e.target.value);

        let emails = value.split(',').map((email) => {
            return $.trim(email);
        }).filter((email) => {
            return email !== '';
        });

        let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
        let helper_email_error = [];
        let isValid_emails = [];
        emails.map(email => {
            if (emailRegex.test(email)) {
                isValid_emails.push(true);
            } else {
                helper_email_error.push(email);
                isValid_emails.push(false);
            }
        })
        /*let isValid = emails.every(function (email) {
            if (emailRegex.test(email)) {
                return true;
            } else {
                helper_email_error.push(email);
                return false;
            }

        });*/

        let isValid = isValid_emails.every(valor => {
            return valor === true;
        })

        if (!isValid) {
            $(`#${e.target.dataset.validate}`).attr('disabled', 'disabled');
            e.target.classList.add('is-invalid');
            $(`#${e.target.dataset.helper}`).text(`Correos que no cumplen con los requisitos: ${helper_email_error.join(', ')}`)
        } else {
            $(`#${e.target.dataset.validate}`).removeAttr('disabled');
            e.target.classList.remove('is-invalid');
            $(`#${e.target.dataset.helper}`).text('')
            helper_email_error = []
            // console.log(e.target);
        }
    }

    validate_date(e) {
        let value = $.trim(e.target.value);

        if (value === '') {
            $(`#${e.target.dataset.validate}`).attr('disabled', 'disabled')
        } else {
            $(`#${e.target.dataset.validate}`).removeAttr('disabled')
        }
    }

    // ─── Helper: obtener agency_id según el contexto del usuario ───
    _getAgencyId() {
        if (this.hasAgencySelectTarget) {
            return this.agencySelectTarget.value || null;
        }
        return null; // usuario agency normal: el backend usa current_user.admin_agency_id
    }
}